
















import Vue from "vue";
import ObjectMarkEdit from "../components/ObjectMarkEdit.vue";
import eventBus from "@/services/eventBus";

import store, { ObjectMarkStore } from "../services/ObjectMarkStore";
import { GeneralObjectMarkTagDefaultProps } from "../models/GeneralObjectMarkTag";
import { TagTableRelation } from "../models/TagTableRelation";

interface Data {
  store: ObjectMarkStore;
}

interface Methods {
  createItem(): void;
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    ObjectMarkEdit,
  },

  data() {
    return {
      store,
    };
  },

  methods: {
    createItem(): void {
      eventBus.$emit(`ObjectMarkApiSearch:add-item`, {...GeneralObjectMarkTagDefaultProps, tableName: TagTableRelation.GeniItem, inEdit: true, deleted: true}); //Bővítjük az ApiSearchPage items obj[] -át
    },
  }
});
